import React from 'react';
import { useHistory } from 'react-router';
import { ContentSpacer } from '../../../../../global/components/layout/generic-content-spacer';
import { SideBarContent } from '../../../../../global/components/layout/sidebar-content';
import { TcsmContentLinkView } from '../../../../../global/components/tcsm-content-link';
import { WysiwygWithReactLink } from '../../../../../global/components/wysiwyg-with-react-link';
import { getFormattedDate } from '../../../../../global/helpers/date-helpers';
import { stringDateSort } from '../../../../../global/helpers/sort-helper';
import { TcsmNewsUpdateBlock } from '../../../../../global/models/tcsm-block-models';

interface Props {
    newsUpdatesItems: TcsmNewsUpdateBlock[];
    latestUpdatesHeader: string;
    sidebarInfoBoxHeader: string;
    sidebarInfoBoxContent: string;
    newsUpdatesPath: string;
}

export function PortalSidebar(props: Props) {
    const {
        newsUpdatesItems,
        newsUpdatesPath,
        latestUpdatesHeader,
        sidebarInfoBoxHeader,
        sidebarInfoBoxContent,
    } = props;

    const history = useHistory();

    const latest5Updates = newsUpdatesItems?.sort((a, b) => {
        return stringDateSort(a.date, b.date);
    }).slice(0, 5);


    const renderLatestUpdate = (item: TcsmNewsUpdateBlock, index: number) => {
        return (
            <li className='dashboard-sidebar-update-list-item' key={item.title + index}>
                <span className='dashboard-sidebar-update-list-item-date'>{getFormattedDate(item.date)}</span>
                <TcsmContentLinkView link={item.itemLink} text={item.title} />
            </li>
        );
    };

    const onViewMoreClick = () => {
        history.push(newsUpdatesPath);
    };


    return (
        <>
            <SideBarContent>
                <div className='sidebar'>
                    {
                        (sidebarInfoBoxHeader || sidebarInfoBoxContent) &&
                        <div className='sidebar-section'>
                            <ContentSpacer>
                                <h2>{sidebarInfoBoxHeader}</h2>
                            </ContentSpacer>
                            <WysiwygWithReactLink content={sidebarInfoBoxContent} />
                        </div>
                    }
                    <div className='sidebar-section'>
                        <ContentSpacer>
                            {
                                latestUpdatesHeader &&
                            <ContentSpacer>
                                <h2>{latestUpdatesHeader}</h2>
                            </ContentSpacer>
                            }
                            <ul className='dashboard-sidebar-update-list'>
                                {
                                    latest5Updates?.map((item, index) => renderLatestUpdate(item, index))
                                }
                            </ul>
                        </ContentSpacer>
                        <button className='btn-secondary' type='button' onClick={onViewMoreClick}>View More</button>
                    </div>

                </div>
            </SideBarContent>
        </>
    );
}
